<template>
    <div class="card">
        <div class="card-content">
            <div class="card-carousel">
                <div class="card-img">
                    <div class="card-img-holder">
                        <img :src="images[activeImage]" alt="Product afbeelding" />
                    </div>
                    <div class="actions">
                        <span @click="prevImage" class="prev">
                            <i class="fa fa-chevron-left"></i>
                        </span>
                        <span @click="nextImage" class="next">
                            <i class="fa fa-chevron-right"></i>
                        </span>
                    </div>
                </div>
                <div class="thumbnails">
                    <div v-for="(image, index) in images" :key="image" :class="['thumbnail-image', (activeImage == index) ? 'active' : '']" @click="activateImage(index)">
                        <img :src="image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            activeImage: 0
        }
    },
    props: {
        images: Array
    },
    methods: {
        nextImage () {
            let active = this.activeImage + 1

            if (active >= this.images.length) {
                active = 0
            }
            this.activateImage(active)
        },
        prevImage () {
            let active = this.activeImage - 1
            if (active < 0) {
                active = this.images.length - 1
            }
            this.activateImage(active)
        },
        activateImage (imageIndex) {
            this.activeImage = imageIndex
        }
    }
}
</script>
<style>
.card-warehouse {
    min-height: 400px;
}
.card-carousel {
    user-select: none;
    position: relative;
}
.progressbar {
    display: block;
    width: 100%;
    height: 5px;
    position: absolute;
    background-color: rgba(221, 221, 221, 0.25);
    z-index: 1;
}
.progressbar>div {
    background-color: rgba(255, 255, 255, 0.52);
    height: 100%;
}
.thumbnails {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    padding-bottom: 15px;
}
.thumbnail-image {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 2px;
}
.thumbnail-image>img {
    height: auto;
    transition: all 250ms;
    max-height: 150px;
    max-width: 150px;
    width: auto;
}
.thumbnail-image:hover>img,
.thumbnail-image.active>img {
    opacity: 0.6;
}
.card-img {
    position: relative;
    margin-bottom: 15px;
    margin-bottom: 50px;
    max-width: 95%;
    padding-top: 2.5%;
    margin: auto;
    white-space: nowrap;
}
.card-img-holder {
    height: 100%;
    vertical-align: middle;
}
.card-img .card-img-holder img {
    max-height: 100%;
    display: block;
    margin: auto;
}
.actions {
    font-size: 1.5em;
    height: 40px;
    position: absolute;
    top: 50%;
    margin-top: -20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #585858;
}
.actions>span {
    cursor: pointer;
    transition: all 250ms;
}
.actions>span.prev {
    margin-left: 5px;
}
.actions>span.next {
    margin-right: 5px;
}
.actions>span:hover {
    color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/Global/ProductGallery.vue